import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './index.scss'

class EntryTime extends Component {
  render () {
    return (
      <time
        className='entry-date'
        dateTime={this.props.date}>{new Date(this.props.date).toLocaleDateString('en-GB').replace(/\//g, '.')}
      </time>
    )
  }
}

EntryTime.propTypes = {
  date: PropTypes.string
}

export default EntryTime



// WEBPACK FOOTER //
// ./src/components/EntryDate/index.js